var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.06956 12.543L16.4291 20.508C16.5685 20.641 16.7539 20.7151 16.9466 20.7151C17.1393 20.7151 17.3246 20.641 17.4641 20.508L17.4731 20.499C17.5409 20.4345 17.5949 20.357 17.6319 20.271C17.6688 20.185 17.6878 20.0923 17.6878 19.9988C17.6878 19.9052 17.6688 19.8126 17.6319 19.7266C17.5949 19.6406 17.5409 19.563 17.4731 19.4985L9.60106 11.9985L17.4731 4.50151C17.5409 4.43705 17.5949 4.35946 17.6319 4.27346C17.6688 4.18746 17.6878 4.09485 17.6878 4.00126C17.6878 3.90767 17.6688 3.81506 17.6319 3.72906C17.5949 3.64306 17.5409 3.56547 17.4731 3.50101L17.4641 3.49201C17.3246 3.35904 17.1393 3.28486 16.9466 3.28486C16.7539 3.28486 16.5685 3.35904 16.4291 3.49201L8.06956 11.457C7.99605 11.5271 7.93752 11.6113 7.89753 11.7046C7.85754 11.798 7.83691 11.8985 7.83691 12C7.83691 12.1016 7.85754 12.202 7.89753 12.2954C7.93752 12.3887 7.99605 12.473 8.06956 12.543Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackarrow);
export default __webpack_public_path__ + "static/media/backarrow.fbd994b055a7d773517064a824f09dfa.svg";
export { ForwardRef as ReactComponent };